/* import __COLOCATED_TEMPLATE__ from './company-table-row-component.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class CompanyTableRow extends Component {
  @tracked isHovered = false;

  get shouldHaveVisibleCheckbox() {
    return this.isHovered || this.args.hasSelectedUsers;
  }
}
